(() => {
  if (window.__plaudSiteNavV3Initialized) return;
  window.__plaudSiteNavV3Initialized = true;

  const resetNestedState = (root) => {
    if (!root) return;

    root.querySelectorAll('menu-item.is-open').forEach((item) => {
      item.classList.remove('is-open');
    });
    root.querySelectorAll('.mobile-accordion-content.is-open').forEach((content) => {
      content.classList.remove('is-open');
    });
    root.querySelectorAll('[data-accordion-trigger][aria-expanded="true"]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
    root.querySelectorAll('open-children-toggle[aria-expanded="true"]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
    });
    // Default-open accordions reset to expanded, not collapsed.
    root.querySelectorAll('[data-accordion-default-open] .mobile-accordion-content').forEach((content) => {
      content.classList.add('is-open');
    });
    root.querySelectorAll('[data-accordion-default-open] [data-accordion-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'true');
    });
  };

  const resetMobileState = () => {
    resetNestedState(document.querySelector('.site-header--new'));
  };

  let navigationWasOpen = document.documentElement.classList.contains('nav-open');
  const navigationObserver = new MutationObserver(() => {
    const navigationIsOpen = document.documentElement.classList.contains('nav-open');
    if (navigationWasOpen && !navigationIsOpen) resetMobileState();
    navigationWasOpen = navigationIsOpen;
  });

  navigationObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class']
  });

  document.addEventListener('click', (event) => {
    if (!event.target || typeof event.target.closest !== 'function') return;
    const backControl = event.target.closest('.site-header--new back-menu');
    if (!backControl) return;
    const panel = backControl.closest('.site-nav-v3--mobile, .site-nav-v3__account-panel');
    if (!panel) return;
    requestAnimationFrame(() => resetNestedState(panel));
  });

  document.addEventListener('shopify:section:load', () => {
    if (!document.querySelector('.site-header--new')) return;
    navigationWasOpen = document.documentElement.classList.contains('nav-open');
  });
})();
